<template>
    <div style="display: flex ; flex-wrap: wrap;">
        <el-select v-model="query.category_id" placeholder="分类" multiple clearable style="width: 250px; margin-left: 3px">
            <el-option v-for="c in category_list" :label="c.i18n_name.ZH_HANS || c.i18n_name.EN" :value="c.id"></el-option>
        </el-select>
        <el-cascader
            :options="content_tag" placeholder="主要标签" clearable size="default" filterable style="width: 100px; margin-left: 3px"
            :props="{
                    expandTrigger: 'hover',
                    label: 'name',
                    value: 'name',
                    emitPath: true,
                    checkStrictly: true
                  }"
            :show-all-levels="false" @change="selectMajorTags" @clear="selectMajorTags([])"/>
<!--        <el-select v-model="query.module" placeholder="模块" clearable style="width: 150px; margin-left: 3px">-->
<!--            <el-option v-for="(v, k) in image_module_enum" :label="v" :value="parseInt(k)"></el-option>-->
<!--        </el-select>-->
        <el-select v-model="query.mi_status" placeholder="图片状态" clearable style="width: 100px; margin-left: 3px">
          <el-option v-for="(v, k) in mi_status_enum" :label="v" :value="parseInt(k)"></el-option>
        </el-select>
<!--        <el-select v-model="query.mi" placeholder="是否选中" clearable style="width: 100px; margin-left: 3px">-->
<!--          <el-option label="选中图片" :value="true"></el-option>-->
<!--          <el-option label="待选图片" :value="false"></el-option>-->
<!--        </el-select>-->
        <el-input v-model="query.id" style="width: 200px; margin-left: 3px" placeholder="图片ID"></el-input>
    </div>
    <el-table style="margin-top: 20px;" v-loading="loading" :data="dataPage">
        <el-table-column label="预览图" width="250">
            <template #default="scope">
                <el-image lazy :src="`${$root.cdn_url}/${scope.row.thumbnail}`" style="width: 100px"></el-image>
                <el-image lazy :src="`${$root.cdn_url}/${scope.row.finished}`" style="width: 100px"
                          v-if="scope.row.finished"></el-image>
                <div style="display: inline-block;width: 100px;height: 100px" v-loading="true" v-else></div>
            </template>
        </el-table-column>
        <el-table-column label="id" prop="id" width="200"></el-table-column>
<!--        <el-table-column label="模块" prop="module" width="100">-->
<!--            <template #default="scope">-->
<!--                {{ image_module_enum[scope.row.module] }}-->
<!--            </template>-->
<!--        </el-table-column>-->
        <el-table-column label="难度" prop="difficulty" width="60">
        </el-table-column>
        <el-table-column label="分类" prop="categories" width="150">
            <template #default="scope">
                <template v-for="c in scope.row.categories">
                    <template v-for="cc in category_list">
                        <el-tag size="small" v-if="cc.id===c">{{ cc.i18n_name.EN }}</el-tag>
                    </template>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="主要内容" prop="major_tags" width="100">
          <template #default="scope">
            <el-tag size="small" v-for="t in scope.row.major_tags">{{ t }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="次要内容" prop="minor_tags" width="100">
          <template #default="scope">
            <el-tag size="small" v-for="t in scope.row.minor_tags">{{ t }}</el-tag>
          </template>
        </el-table-column>
<!--        <el-table-column label="新线稿画法" width="120">-->
<!--          <template #default="scope">-->
<!--            <el-tag v-if="scope.row.new_line_art" size="small">{{ 'Yes' }}</el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="图片状态" width="100">
          <template #default="scope">
            <el-tag v-if="scope.row.mi_status" size="small">{{ mi_status_enum[scope.row.mi_status] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="550">
            <template #default="scope">
                <el-button v-if="scope.row.mi_status === 1" type="danger" size="small" :disabled="loading" @click="selectImage(scope.row, false)">取消选择</el-button>
                <el-button v-else-if="!scope.row.mi_status" type="primary" size="small" :disabled="loading" @click="selectImage(scope.row, true)">选择</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div style="margin-top: 10px;text-align: center;">
        <el-pagination v-model:current-page="page" :page-size="size" layout="prev, pager, next"
                       :total="dataFilter.length"></el-pagination>
    </div>
</template>

<script>
import axios from 'ts-axios-new';
import {timestampToDate, update} from "../libs/utils";
import {has_feature_reprocess} from "../libs/permission";

export default {
    name: 'Index',
    data() {
        return {
            loading: false, data: [], category_list: [], page: 1, size: 50,
            editing: null, content_tag: [], style_tag: [], total: 0, major: null, minor: null, style: null,
            image_module_enum: {1: '图库', 2: 'DAILY'}, history: [], history_list: [],
            mi_status_enum: {0: '未选中', 1: '已选中', 2: '处理中', 3: '已完成'},
            query: {
                id: null,
                module: null,
                category_id: null,
                difficulty: null,
                mi_status: null,
                major_tag: null,
            },
            image_url: "/cms/v1/mi/image",
        }
    },
    methods: {
        init() {
            this.loading = true;
            axios.all([
                axios.get(`${this.image_url}`).then(res => {
                    this.data = res.data.data.imageList;
                    this.total = this.data.length;
                }),
                axios.get('/cms/v1/category').then(res => {
                    // this.category_list = res.data.data.categoryList;
                    this.category_list = res.data.data.categoryList.filter(item => {
                      return item.key !== 'COLLECTION' && item.key !== 'NEW';
                    });
                }),
                axios.get(`/cms/v1/tag/content`).then(res => {
                  this.content_tag = res.data.data.tagList;
                }),
                axios.get(`/cms/v1/tag/style`).then(res => {
                  this.style_tag = res.data.data.tagList;
                }),
            ]).then(_ => {
                this.loading = false;
            })
        },
        reset() {
            // this.$refs.form.resetFields();
            // this.form = this.createForm()
            this.loading = false;
        },
        selectImage(row, selected) {
            // row.mi = selected
            axios.put(`/cms/v1/mi/select/image/${row.id}?selected=${selected}`).then(res => {
              if(res.data.data.image) {
                row.mi_status = res.data.data.image.mi_status
              }
            })
        },
        selectMajorTags(value) {
          this.query.major_tag = value.join('/')
        },
    },
    mounted() {
        this.init();
    },
    computed: {
        dataFilter() {
            return this.data.filter(d => {
                return (!this.query.id || (d.id).includes(this.query.id))
                    && (!this.query.category_id || !this.query.category_id.length || this.query.category_id.every(id => d.categories.includes(id)))
                    && (!this.query.module && this.query.module !== 0 || d.module === this.query.module)
                    && (!this.query.major_tag || d.major_tags[0] === this.query.major_tag)
                    && (this.query.mi_status === 0 && !d.mi_status  ||
                        this.query.mi_status && d.mi_status === this.query.mi_status ||
                        !this.query.mi_status && this.query.mi_status !== 0)
                    // && (this.query.mi === true && d.mi === true ||
                    //     this.query.mi === false && d.mi !== true ||
                    //     this.query.mi !== true && this.query.mi !== false)
            })
        },
        dataPage() {
            return this.dataFilter.slice((this.page - 1) * this.size, this.page * this.size);
        }
    }
}
</script>

<style scoped>

.flex-item {
  margin-bottom: 5px; /* 行间距 */
}

</style>